<template>
  <div class="customer_success">
    <p>客户成功案例</p>
    <slot name="img" />
    <div v-if="show" class="customer_success-box">
      <img src="@/assets/page_sanzi.png" alt="">
    </div>
    <h4>{{ title }}</h4>
    <p class="wuzhong_desc">{{ desc }}</p>

  </div>
</template>
<script>
export default {
  name: 'CsBtm',
  props: {
    title: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      arr3: [
        { title: '天安云谷：打造产业园区新生态', content: '携手金蝶我家云构建“园区+互联网”云平台，在企业运营、商业运营、战略决策、全面管控等方面实现线上化、移动化、数据化、智能化。' },
        { title: '深业集团：智慧资产数字化运营管理', content: '深业集团携手金蝶我家云构建“资产管理+用户服务”数字化运营平台，对内进行统一集团管控、策略管控、监管管理、流程管理，提升运营效率，释放管理价值。' }
      ],
      nowindex3: 0
    }
  },
  methods: {
    mouseOver3: function(x) {
      this.nowindex3 = x
    },
    mouseLeave3: function(x) {
      this.nowindex3 = -1
    }
  }
}
</script>
<style scoped>
.customer_success {
  width: 100%;
  height: auto;
  margin: 0 auto;
  padding-top: 85px;
  padding-bottom: 90px;
}
p:nth-child(1) {
    margin: auto;
    width: auto;
    height: auto;
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(6,24,40,1);
}
h4 {
  margin: 20px 0 10px
}
.wuzhong_desc {
    margin: auto;
    margin-top: 20px;
    width: 1000px;
    height: auto;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 300;
    color: rgba(13,10,38,1);
    line-height: 24px;
    text-align: center;
}
.customer_success-box {
  max-width: 1200px;
  margin: 50px auto 0 auto;

}
.customer_success-box  img {
  width: 90%;
  margin: 0 auto;
  border: solid
}
</style>



// WEBPACK FOOTER //
// src/components/CsBtm.vue